document.addEventListener('DOMContentLoaded', () => {
    const targetButton = document.querySelector('.product-form__submit.teste'); // Botão principal
    const fixedButton = document.getElementById('fixedButton'); // Botão fixo

    if (targetButton && fixedButton) {
        function handleButtonVisibility(isVisible) {
            if (!isVisible) {
                console.log('O botão principal saiu da tela!');
                fixedButton.style.display = 'block'; // Garante que o botão fique visível no layout
                setTimeout(() => {
                    fixedButton.style.opacity = '1'; // Gradualmente torna visível
                }, 10); // Timeout para evitar conflito com display
            } else {
                console.log('O botão principal está visível.');
                fixedButton.style.opacity = '0'; // Gradualmente torna invisível
                setTimeout(() => {
                    fixedButton.style.display = 'none'; // Esconde o botão completamente
                }, 300); // Tempo correspondente à transição no CSS
            }
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                handleButtonVisibility(entry.isIntersecting);
            });
        }, { threshold: 1.0 });

        observer.observe(targetButton);
    } else {
        console.error('Um ou ambos os botões não foram encontrados!');
    }
});
